import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from '../utils';
import {
  getDeterministicMatchingConfig,
  getProbabilisticMatchingConfig
} from './matching';
import store from 'src/store';

export const getSystemConfiguration = (entityId, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/system-configuration',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(getSystemConfigSuccess(res.data));
        const currEntity = store.getState().entities.selected;
        // console.log(
        //   'Curr entity name ' +
        //     currEntity.name +
        //     ' and system config ' +
        //     JSON.stringify(res.data)
        // );
        const matchingConfigGetter = getMatchingConfigurationEndpoint(
          currEntity.name,
          res.data
        );
        dispatch(matchingConfigGetter(entityId, sessionId));
      })
      .catch(err => {
        dispatch(getSystemConfigFailure(err));
      });
  };
};

export const getGlobalIdentifierConfig = theSessionId => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    axios({
      method: 'GET',
      url: '/openempi-ws-rest/1.0/system-configuration/global-identifier',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getGlobalIdConfigSuccess(res.data));
      })
      .catch(err => {
        dispatch(getGlobalIdConfigFailure(err));
      });
  };
};

export const saveGlobalIdentifierConfig = (globalIdentifier, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/system-configuration/global-identifier',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: globalIdentifier
    })
      .then(res => {
        dispatch(saveGlobalIdConfigSuccess(res.data));
      })
      .catch(err => {
        dispatch(saveGlobalIdConfigFailure(err));
      });
  };
};

export const getAdminConfig = theSessionId => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    axios({
      method: 'GET',
      url: '/openempi-ws-rest/1.0/system-configuration/admin-configuration',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getAdminConfigSuccess(res.data));
      })
      .catch(err => {
        dispatch(getAdminConfigFailure(err));
      });
  };
};

export const saveAdminConfig = (adminConfig, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/system-configuration/admin-configuration',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: adminConfig
    })
      .then(res => {
        dispatch(saveAdminConfigSuccess(res.data));
      })
      .catch(err => {
        dispatch(saveAdminConfigFailure(err));
      });
  };
};

export const getScheduledTasks = theSessionId => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    axios({
      method: 'GET',
      url: '/openempi-ws-rest/1.0/system-configuration/scheduled-tasks',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getScheduledTasksSuccess(res.data));
      })
      .catch(err => {
        dispatch(getScheduledTasksFailure(err));
      });
  };
};

export const saveScheduledTasks = (scheduledTasks, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/system-configuration/scheduled-tasks',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: scheduledTasks
    })
      .then(res => {
        dispatch(saveScheduledTasksSuccess(res.data));
      })
      .catch(err => {
        dispatch(saveScheduledTasksFailure(err));
      });
  };
};

export const getPerformanceMetrics = theSessionId => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    axios({
      method: 'GET',
      url: '/openempi-ws-rest/1.0/performance-metrics/',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(getPerformanceMetricsSuccess(res.data));
      })
      .catch(err => {
        dispatch(getPerformanceMetricsFailure(err));
      });
  };
};

export const clearGlobalIdentifierError = () => {
  return {
    type: Constants.GLOBALIDCONFIG_CLEAR_ERROR
  };
};

export const clearAdminConfigError = () => {
  return {
    type: Constants.ADMINCONFIG_CLEAR_ERROR
  };
};

export const clearScheduledTasksError = () => {
  return {
    type: Constants.SCHEDULEDTASKS_CLEAR_ERROR
  };
};

const getSystemConfigSuccess = data => {
  return {
    type: Constants.SYSTEMCONFIG_GET_SUCCESS,
    payload: data
  };
};

const getSystemConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.SYSTEMCONFIG_GET_FAILURE,
    payload
  };
};

const getGlobalIdConfigSuccess = data => {
  return {
    type: Constants.GLOBALIDCONFIG_GET_SUCCESS,
    payload: data
  };
};

const getGlobalIdConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.GLOBALIDCONFIG_GET_FAILURE,
    payload
  };
};

const saveGlobalIdConfigSuccess = data => {
  return {
    type: Constants.GLOBALIDCONFIG_SAVE_SUCCESS,
    payload: data
  };
};

const saveGlobalIdConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.GLOBALIDCONFIG_SAVE_FAILURE,
    payload
  };
};

const getAdminConfigSuccess = data => {
  return {
    type: Constants.ADMINCONFIG_GET_SUCCESS,
    payload: data
  };
};

const getAdminConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.ADMINCONFIG_GET_FAILURE,
    payload
  };
};

const saveAdminConfigSuccess = data => {
  return {
    type: Constants.ADMINCONFIG_SAVE_SUCCESS,
    payload: data
  };
};

const saveAdminConfigFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.ADMINCONFIG_SAVE_FAILURE,
    payload
  };
};

const getScheduledTasksSuccess = data => {
  return {
    type: Constants.SCHEDULEDTASKS_GET_SUCCESS,
    payload: data
  };
};

const getScheduledTasksFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.SCHEDULEDTASKS_GET_FAILURE,
    payload
  };
};

const getPerformanceMetricsSuccess = data => {
  return {
    type: Constants.PERFORMANCEMETRICS_GET_SUCCESS,
    payload: data
  };
};

const getPerformanceMetricsFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.PERFORMANCEMETRICS_GET_FAILURE,
    payload
  };
};

const saveScheduledTasksSuccess = data => {
  return {
    type: Constants.SCHEDULEDTASKS_SAVE_SUCCESS,
    payload: data
  };
};

const saveScheduledTasksFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.SCHEDULEDTASKS_SAVE_FAILURE,
    payload
  };
};

const getMatchingConfigurationEndpoint = (entityName, systemConfig) => {
  const matchingAlgorithm = systemConfig[entityName].matchingAlgorithmName;
  return matchingAlgorithm &&
    matchingAlgorithm === 'Probabilistic Matching Algorithm'
    ? getProbabilisticMatchingConfig
    : getDeterministicMatchingConfig;
};
